export default __webpack_public_path__ + "static/media/Request.3055f292.svg";